// Só envia a Saúde no Controle Inteligente quando o valor é conhecido, para não sobrescrever o salvo com o padrão.
export function healthRemoteControlPayload(visible: boolean | null): { REMOTE_CONTROL_HEALTH_VISIBLE?: boolean } {
  if (visible == null) return {};
  return { REMOTE_CONTROL_HEALTH_VISIBLE: visible };
}
